import React, { useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

function PracticeSubjectSidebar(props) {
    const {
        subjects = [],
        selectedSubject,
        setSelectedSubject,
        isSubjectMenuOpen,
        setIsSubjectMenuOpen
    } = props;

    const selectedSubjectName =
        subjects.find((s) => s._id === selectedSubject)?.name || "Select Subject";

    return (
        <div className="w-full lg:w-[233px] bg-[#fff] rounded-2 h-full">

            <div className="lg:hidden mb-4">
                <button
                    disabled={!subjects.length}
                    onClick={() => setIsSubjectMenuOpen(!isSubjectMenuOpen)}
                    className="w-full flex justify-between items-center p-3 rounded border"
                >
                    <span>Subject: {selectedSubjectName}</span>
                    <FiChevronDown />
                </button>

                {isSubjectMenuOpen && subjects.length > 0 && (
                    <div className="mt-2">
                        {subjects.map((sub) => (
                            <div
                                key={sub._id}
                                onClick={() => {
                                    setSelectedSubject(sub._id);
                                    setIsSubjectMenuOpen(false);
                                }}
                                className="p-3 border-b cursor-pointer"
                            >
                                {sub.name}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="hidden lg:block shadow rounded overflow-hidden">
                {subjects.length > 0 ? (
                    subjects.map((sub) => (
                        <div
                            key={sub._id}
                            onClick={() => setSelectedSubject(sub._id)}
                            className={`py-3 font-[500] tracking-tight cursor-pointer ${selectedSubject === sub._id
                                ? "bg-[#4096F6] text-white px-3"
                                : "mx-3 border-b border-[#33333399] text-[#333333]"
                                }`}
                        >
                            {sub.name}
                        </div>
                    ))
                ) : (
                    <div className="p-4 text-center text-gray-500 text-[14px]">
                        No subjects available
                        <br />
                        Please select another exam
                    </div>
                )}
            </div>
        </div>
    );
}

export default PracticeSubjectSidebar;
